/* ═══════════════════════════════════════════════════════════
   SULEMAN TECH — Community Tools Hub · shared helpers (STX)
   No external API keys. jsPDF loaded lazily on first export.
   ═══════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (window.STX) return;

  var STX = {};

  // ── tiny DOM + format helpers ──────────────────────────────
  STX.$  = function (s, r) { return (r || document).querySelector(s); };
  STX.$$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  STX.num = function (v, d) { var n = parseFloat(String(v).replace(',', '.')); return isFinite(n) ? n : (d || 0); };
  STX.eur = function (n) {
    try { return new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(n); }
    catch (e) { return '€' + Math.round(n); }
  };
  STX.esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  // ── WhatsApp link ──────────────────────────────────────────
  STX.wa = function (number, text) {
    var n = String(number || '').replace(/[^0-9]/g, '');
    return 'https://wa.me/' + n + (text ? '?text=' + encodeURIComponent(text) : '');
  };

  // ── pill / segmented control binding ───────────────────────
  // container with [data-stx-pills][data-name]; pills have [data-value]
  STX.bindPills = function (container, onChange) {
    if (!container) return;
    var pills = STX.$$('[data-value]', container);
    pills.forEach(function (p) {
      p.setAttribute('role', 'button');
      if (!p.hasAttribute('aria-pressed')) p.setAttribute('aria-pressed', 'false');
      p.addEventListener('click', function () {
        pills.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        p.setAttribute('aria-pressed', 'true');
        container.dataset.value = p.dataset.value;
        if (onChange) onChange(p.dataset.value, p);
      });
    });
    var first = pills[0];
    if (first && !STX.$('[aria-pressed="true"]', container)) {
      first.setAttribute('aria-pressed', 'true');
      container.dataset.value = first.dataset.value;
    }
  };
  STX.pillValue = function (container, fallback) {
    return (container && container.dataset.value) || fallback || '';
  };

  // ── lazy jsPDF loader ──────────────────────────────────────
  var pdfLoading = null;
  STX.loadPDF = function () {
    if (window.jspdf && window.jspdf.jsPDF) return Promise.resolve(window.jspdf.jsPDF);
    if (pdfLoading) return pdfLoading;
    pdfLoading = new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
      s.async = true;
      s.onload = function () {
        (window.jspdf && window.jspdf.jsPDF) ? resolve(window.jspdf.jsPDF) : reject(new Error('jsPDF missing'));
      };
      s.onerror = function () { reject(new Error('jsPDF failed to load')); };
      document.head.appendChild(s);
    });
    return pdfLoading;
  };

  // Build a simple, clean A4 PDF from {title, brand, lines:[{label,value}|{h:''}|{p:''}]}
  STX.exportPDF = function (opts) {
    return STX.loadPDF().then(function (jsPDF) {
      var doc = new jsPDF({ unit: 'mm', format: 'a4' });
      var W = 210, M = 18, y = 22;
      doc.setFillColor(17, 17, 17); doc.rect(0, 0, W, 30, 'F');
      doc.setTextColor(255, 255, 255); doc.setFont('helvetica', 'bold'); doc.setFontSize(16);
      doc.text(opts.brand || 'SULEMAN TECH', M, 14);
      doc.setFontSize(11); doc.setFont('helvetica', 'normal');
      doc.text(opts.title || '', M, 22);
      y = 42; doc.setTextColor(17, 17, 17);
      (opts.lines || []).forEach(function (ln) {
        if (y > 270) { doc.addPage(); y = 22; }
        if (ln.h) { doc.setFont('helvetica', 'bold'); doc.setFontSize(12); y += 4; doc.text(String(ln.h), M, y); y += 7; }
        else if (ln.p) { doc.setFont('helvetica', 'normal'); doc.setFontSize(10); var w = doc.splitTextToSize(String(ln.p), W - M * 2); doc.text(w, M, y); y += w.length * 5 + 2; }
        else { doc.setFont('helvetica', 'normal'); doc.setFontSize(11); doc.text(String(ln.label || ''), M, y); doc.setFont('helvetica', 'bold'); doc.text(String(ln.value || ''), W - M, y, { align: 'right' }); y += 7; }
      });
      doc.setFontSize(8); doc.setTextColor(120, 120, 120);
      doc.text((opts.footer || 'sulemantech.es') + ' · ' + new Date().toLocaleDateString('es-ES'), M, 287);
      doc.save((opts.filename || 'sulemantech') + '.pdf');
    }).catch(function () { alert('No se pudo generar el PDF. Inténtalo de nuevo.'); });
  };

  // ── on-device save (localStorage) ──────────────────────────
  STX.saveLocal = function (key, data) {
    try { localStorage.setItem('stx:' + key, JSON.stringify({ t: Date.now(), data: data })); return true; }
    catch (e) { return false; }
  };
  STX.readLocal = function (key) {
    try { var r = localStorage.getItem('stx:' + key); return r ? JSON.parse(r) : null; } catch (e) { return null; }
  };

  // ── account-nudge modal ────────────────────────────────────
  STX.nudgeAccount = function () {
    var m = STX.$('#stx-account-modal');
    if (m) m.setAttribute('open', '');
  };
  document.addEventListener('click', function (e) {
    var m = STX.$('#stx-account-modal');
    if (!m) return;
    if (e.target === m || e.target.hasAttribute('data-stx-close')) m.removeAttribute('open');
  });

  // ── donation buttons (link to configured URL) ──────────────
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-stx-coffee]');
    if (!btn) return;
    var base = btn.getAttribute('data-coffee-url') || '';
    var amt = btn.getAttribute('data-stx-coffee') || '';
    if (!base) { alert('Configura la URL de donación en los ajustes de la sección.'); return; }
    if (amt === 'custom') { window.open(base, '_blank', 'noopener'); return; }
    var sep = base.indexOf('?') > -1 ? '&' : '?';
    window.open(base + sep + 'amount=' + encodeURIComponent(amt), '_blank', 'noopener');
  });

  // ── suggest-a-tool toggle ──────────────────────────────────
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-stx-suggest-toggle]');
    if (!t) return;
    var box = STX.$('#stx-suggest-form');
    if (box) { box.hidden = !box.hidden; if (!box.hidden) box.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
  });

  window.STX = STX;
})();
